import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { Emisor } from './emisor';
import {environment} from '../../src/environments/environment';



@Injectable({
  providedIn: 'root'
})
export class EmisorService {

  constructor(private http: HttpClient) {

  

   }


  getEmisor(ruc:string) {  
    
    return this.http.get<Emisor[]>(environment.apiUrl + '/buscarEmisorPorId/?id=' +ruc);  
  }  



  
  setActulizarCliente(emisor: Emisor[]){
    console.log(emisor);
    return this.http.put<string>(environment.apiUrl+"/actulizarEmisor",emisor);
  }

  abrirGaveta(id:string) {  
    
    return this.http.get<Emisor[]>(environment.apiUrl + '/abrirGaveta/?id=' +id+'&gaveta=S');  
  }  



  imprimirLocal(id:string,url:string,factura) {  
    
    return this.http.get<Emisor[]>(environment.apiUrl + '/imprimirCaja/?id=' +id+'&reporte='+url+'&factura='+factura);  
  }  



}
